"use client";

import { useEffect, useState } from "react";

const DateTimeNow = () => {
	const [year, setYear] = useState<number>(new Date().getFullYear());

	useEffect(() => {
		// Update year on client mount
		setYear(new Date().getFullYear());
	}, []);

	return <span suppressHydrationWarning>{year}</span>;
};

export default DateTimeNow;
